const autoNgTemplateLoaderTemplate1 = require('./customer-goal-tab.template.html');

'use strict';

angular
    .module('app')
    .directive('customerGoalTab', customerGoalTab);

customerGoalTab.$inject = [];

function customerGoalTab() {
    return {
        restrict: 'E',
        scope: {
            userId: '=',
            firstScan: '=',
        },
        templateUrl: autoNgTemplateLoaderTemplate1,
        controller: 'CustomerGoalTabController',
        controllerAs: 'vm',
    };
}
